{
  "viralRecording": {
    "status": {
      "loading": "Loading...",
      "loadingProcessData": "Loading process data...",
      "loadingRecordingData": "Loading recording data..."
    },
    "buttons": {
      "startRecording": "Start Recording",
      "finishing": "Finishing...",
      "finishRecording": "Finish Recording",
      "save": "Save",
      "delete": "Delete",
      "addCondition": "Add Condition",
      "addRule": "Add Rule",
      "reorderRule": "Drag to reorder rule",
      "back": "Back",
      "addNewInput": "Add Input",
      "seeMoreAndChange": "See more and change",
      "createStartEvent": "Create Start Event"
    },
    "labels": {
      "startEvent": "Start Event",
      "previousEvent": "Previous Event",
      "noDescriptionAvailable": "No description available",
      "rule": "Rule",
      "ruleNumber": "Rule {{number}}",
      "unclear": "Unclear",
      "none": "None",
      "theProcessWillEndHere": "The process will end here.",
      "iReceive": "I Receive",
      "iDo": "I Do",
      "iUse": "I Use",
      "iCreate": "I Create",
      "youLabel": "{{name}} (You)",
      "event": "Event",
      "information": "Information",
      "untitled": "Untitled",
      "processStepDescription": "Process Step Description",
      "processInformation": "Provide the process name and description",
      "processDetailsOverview": "Overview of this process's master data",
      "process": "Activity",
      "decision": "Decision",
      "defineOutput": "Define Output",
      "unknownUser": "Unknown User",
      "unknownRole": "Unknown Position",
      "processName": "Process Name",
      "description": "Description",
      "organizationInfo": "Organization Information",
      "owner": "Process owner",
      "createdBy": "Created By",
      "department": "Department",
      "timestamps": "Timestamps",
      "createdAt": "Created At",
      "updatedAt": "Last Updated",
      "decisionRules": "Decision Rules",
      "clickToOpen": "Click to open decision table",
      "clickToEdit": "Click to edit",
      "result": "Result",
      "outputHint": "What happens next when these conditions apply? Please phrase it independently of any person (Good: “Standard sales process”, “Special sales process”. Bad: “Hand it off to Peter”)."
    },
    "placeholders": {
      "noInputsAddedYet": "No inputs added yet",
      "defineProcessStepDescription": "Define Process Step description...",
      "choose": "Choose",
      "enterCondition": "e.g., Order value > 100€",
      "enterConditionAlt": "e.g., Order value < 100€",
      "enterCondition2": "e.g., Customer type = Premium",
      "enterCondition2Alt": "e.g., Customer type = Standard",
      "enterOutput": "e.g., Approve automatically",
      "enterOutput2": "e.g., Request manager approval"
    },
    "sections": {
      "inputsReceived": "Events & Information",
      "helpers": "Helpers"
    },
    "modals": {
      "eventModal": {
        "editEventTitle": "Edit Start Event",
        "createEventTitle": "Create Start Event",
        "startEventDescription": "Define the trigger that starts this process.",
        "type": "Type",
        "trigger": "Trigger",
        "eventName": "Event name",
        "selectTrigger": "Select trigger",
        "selectEventType": "Select event type",
        "enterEventName": "Enter event name",
        "describeWhatTriggers": "Describe what triggers this event"
      },
      "decisionTable": {
        "title": "Decision Table",
        "descriptionNew": "Define decision rules using custom conditions. Each rule creates a successor card.",
        "configureRulesDescription": "Configure decision rules to determine the next action based on conditions",
        "emptyCondition": "Empty condition",
        "validationMessageNew": "Each rule must have at least one condition filled and an output",
        "successorReminder": "Remember to assign successors to each rule after saving the decision table",
        "defaultCondition": "Condition {{number}}",
        "editColumnName": "Click to edit column name",
        "orSeparator": "or"
      },
      "inputModal": {
        "editTitle": "Edit Input",
        "viewTitle": "View Input",
        "addTitle": "Add Input",
        "description": "What events trigger this step or what is needed to perform the step. (e.g., a report, metrics, etc.)",
        "inputTypeSection": "Input Type",
        "eventDetails": "Event Details",
        "informationDetails": "Information Details",
        "inputTypeEvent": "Event",
        "inputTypePreviousOutput": "Information (From previous step)",
        "informationName": "Information name",
        "enterInformationName": "e.g., Customer details",
        "describeInformation": "Describe what this information contains",
        "linkToProcessStep": "Link to a process step",
        "linkToProcessStepHint": "Choose the steps whose result must be available before this step can start.",
        "selectProcessStep": "Search for a step...",
        "noCompletedSteps": "No completed steps available",
        "allStepsAlreadyLinked": "All available steps are already linked",
        "outputLabel": "Output: {{output}}",
        "linkedStepNotFound": "Linked step no longer available",
        "inputType": "Type",
        "selectInputType": "Select input type"
      }
    },
    "helpersHeading": {
      "systems_one": "1 System",
      "systems_other": "{{count}} Systems",
      "participants_one": "1 Participant",
      "participants_other": "{{count}} Participants",
      "colleagues_one": "1 Colleague",
      "colleagues_other": "{{count}} Colleagues",
      "documents_one": "1 Document",
      "documents_other": "{{count}} Documents",
      "addHint": "Add",
      "pendingSystem": "Pending system",
      "pendingFunction": "Suggested team or function"
    },
    "tooltips": {
      "input": "Add everything here that comes in and that you need to carry out the process step: an event that triggers the step (e.g. a quarterly meeting) or information you process (e.g. a report or metric). Pure reference material such as guidelines belongs under 'Documents' instead.",
      "actionType": "Describe what happens in this step. If it is a normal activity, choose 'Activity'. If what happens next depends on conditions (e.g. approved/rejected), choose 'Decision'.",
      "helpers": "What and who do you use to complete this step? Systems used, people who must be involved, and documents you need.",
      "documents": "Documents are only consulted – guidelines, checklists, templates. They stay unchanged. What you process and pass on belongs as 'Information' in the input."
    }
  },
  "entityPicker": {
    "common": {
      "allFacet": "All",
      "noResults": "No results found",
      "recommendedBadge": "RECOMMENDED",
      "matchInFieldTemplate": "— Match in {{field}}",
      "statsLine": "in {{occurrences}} of {{samples}} recordings ({{percent}}%)",
      "departmentFilterAll": "All departments",
      "departmentFilterAriaLabel": "Filter by department",
      "departmentFilterPrefix": "Department:",
      "fields": {
        "email": "Email",
        "description": "Description",
        "role": "Position",
        "department": "Department",
        "category": "Category",
        "type": "Type",
        "name": "Name"
      },
      "buckets": {
        "recentlyUsed": "Recently used by you",
        "recentlyUsedSubtitle_one": "based on your last recording",
        "recentlyUsedSubtitle_other": "based on your last {{count}} recordings",
        "selected": "Selected ({{count}})",
        "pendingSuggestions": "Pending suggestions"
      },
      "selectedSectionLabel_one": "Selected ({{count}})",
      "selectedSectionLabel_other": "Selected ({{count}})",
      "removeChipAriaLabel": "Remove {{name}}",
      "switchToAllLabel": "Show all {{count}}",
      "switchToBucketsLabel": "Show suggestions",
      "allGroupSelectedLabel": "Selected ({{count}})"
    },
    "system": {
      "title": "Choose systems",
      "description": "Which systems do you use in this step? Multi-select.",
      "searchPlaceholder": "System name, vendor or category",
      "empty": "No systems match",
      "saveSingular": "Save (1 system)",
      "savePlural": "Save ({{count}} systems)",
      "saveZero": "Save",
      "requestNewTitle": "Request new system",
      "requestNewDescription": "An admin will review and add it to the library.",
      "allGroupRestLabel": "More systems ({{count}})",
      "showAllCtaTitle": "Browse all systems",
      "showAllCtaMeta": "{{count}} systems · filter by category",
      "suggestRowTitle": "System not listed?",
      "suggestRowMeta": "Suggest a new system for the recording library.",
      "emptyStateCtaWithQuery": "Suggest \"{{query}}\" as a new system",
      "emptyStateCtaBlank": "Suggest new system",
      "createRowMeta": "Create a new system.",
      "createCtaWithQuery": "Create \"{{query}}\" as a new system",
      "createCtaBlank": "Create new system",
      "buckets": {
        "recentlyUsed": "Recently used by you",
        "recentlyUsedSubtitle_one": "based on your last recording",
        "recentlyUsedSubtitle_other": "based on your last {{count}} recordings",
        "byRole": "Common in your position",
        "byRolePeerCount": "{{count}} colleagues with the same position",
        "byProcess": "For this process",
        "byProcessSampleSize": "from {{count}} similar recordings",
        "byDepartment": "Common in your department",
        "byDepartmentPeerCount": "{{count}} colleagues in your department",
        "annotation": {
          "recentlyUsed": "last used by you",
          "byRole": "{{count}} colleagues use this",
          "byProcess": "in {{count}} similar recordings",
          "byDepartment": "{{count}} colleagues in your department use this"
        }
      },
      "resultCount_one": "{{count}} match",
      "resultCount_other": "{{count}} matches",
      "helperAvailableAsSuccessor": "Previously suggested as helper"
    },
    "user": {
      "title": "Choose participants",
      "description": "Choose people who actively contribute to this step – e.g. for four-eyes approval or joint processing. Multiple possible.",
      "searchPlaceholder": "Name, position, department or email",
      "empty": "No matching colleagues",
      "saveSingular": "Save (1 colleague)",
      "savePlural": "Save ({{count}} colleagues)",
      "saveZero": "Save",
      "allGroupRestLabel": "More colleagues ({{count}})",
      "showAllCtaTitle": "Browse all colleagues",
      "showAllCtaMeta": "{{count}} colleagues · filter by department",
      "buckets": {
        "byRole": "Common in your position",
        "byDepartment": "Common in your department",
        "byProcess": "Frequent for this process step"
      }
    },
    "helper": {
      "title": "Choose people or functions",
      "description": "Choose who actively contributes to this step — individual people, or a whole team or function. Multiple possible.",
      "saveSingular": "Save (1 participant)",
      "savePlural": "Save ({{count}} participants)",
      "kind": {
        "person": "People",
        "team": "Teams",
        "role": "Functions"
      }
    },
    "artifact": {
      "title": "Choose document",
      "description": "Which document do you draw on in this step? E.g. a policy or checklist.",
      "searchPlaceholder": "Searches name, description, type and tags",
      "empty": "No documents match",
      "noDataTitle": "No documents yet",
      "noDataMessage": "Create your first document to start linking it to process steps.",
      "saveSingular": "Save (1 document)",
      "savePlural": "Save ({{count}} documents)",
      "saveZero": "Save",
      "allGroupRestLabel": "More documents ({{count}})",
      "showAllCtaTitle": "Browse all documents",
      "showAllCtaMeta": "{{count}} documents · filter by type",
      "suggestRowTitle": "Document not found?",
      "suggestRowMeta": "Create a new document in the library",
      "emptyStateCtaWithQuery": "Create \"{{query}}\" as a new document",
      "emptyStateCtaBlank": "Document not found? Create new",
      "buckets": {
        "byProcess": "Frequent for this process step",
        "byType": "Typical {{type}} documents"
      }
    },
    "orgFunction": {
      "buckets": {
        "byDepartment": "Common in your department",
        "byProcess": "Frequent for this process step"
      },
      "helperAvailableAsSuccessor": "Previously suggested for this step"
    },
    "team": {
      "title": "Choose team",
      "description": "Which team will take over the next step?",
      "searchPlaceholder": "Name, department or email",
      "empty": "No teams match",
      "saveSingular": "Save (1 team)",
      "savePlural": "Save ({{count}} teams)",
      "saveZero": "Save",
      "allGroupRestLabel": "More teams ({{count}})",
      "showAllCtaTitle": "Browse all teams",
      "showAllCtaMeta": "{{count}} teams · filter by department",
      "suggestRowTitle": "Team missing?",
      "suggestRowMeta": "Suggest a new team for the recording library.",
      "emptyStateCtaWithQuery": "Suggest \"{{query}}\" as a new team",
      "emptyStateCtaBlank": "Suggest new team",
      "createRowMeta": "Create a new team.",
      "createCtaWithQuery": "Create \"{{query}}\" as a new team",
      "createCtaBlank": "Create new team"
    },
    "role": {
      "title": "Choose function",
      "description": "Which function will take over the next step?",
      "searchPlaceholder": "Name, mandate, department or email",
      "empty": "No functions match",
      "saveSingular": "Save (1 function)",
      "savePlural": "Save ({{count}} functions)",
      "saveZero": "Save",
      "allGroupRestLabel": "More functions ({{count}})",
      "showAllCtaTitle": "Browse all functions",
      "showAllCtaMeta": "{{count}} functions · filter by department",
      "suggestRowTitle": "Function missing?",
      "suggestRowMeta": "Suggest a new function for the recording library.",
      "emptyStateCtaWithQuery": "Suggest \"{{query}}\" as a new function",
      "emptyStateCtaBlank": "Suggest new function",
      "createRowMeta": "Create a new function.",
      "createCtaWithQuery": "Create \"{{query}}\" as a new function",
      "createCtaBlank": "Create new function"
    },
    "externalContact": {
      "title": "Choose external contact",
      "description": "Which external contact will the process be handed off to?",
      "searchPlaceholder": "Name, organization, type, email or description",
      "empty": "No contacts match",
      "noDataTitle": "No external contacts yet",
      "noDataMessage": "Add a first contact (customer, supplier, partner…) to start using it in process steps.",
      "saveSingular": "Save (1 contact)",
      "savePlural": "Save ({{count}} contacts)",
      "saveZero": "Save",
      "allGroupRestLabel": "More contacts ({{count}})",
      "showAllCtaTitle": "Browse all contacts",
      "showAllCtaMeta": "{{count}} contacts · filter by type",
      "suggestRowTitle": "Contact not listed?",
      "suggestRowMeta": "Add a new external contact.",
      "emptyStateCtaWithQuery": "Add \"{{query}}\" as a new contact",
      "emptyStateCtaBlank": "Contact not listed? Add one",
      "buckets": {
        "byProcess": "Frequent for this process step",
        "byType": "Typical {{type}} contacts"
      }
    },
    "successor": {
      "title": "Next assignee",
      "breadcrumbAfter": "↳ After \"{{stepName}}\" · Step {{stepNumber}}",
      "descriptionCollapsed": "Who or what takes over the next process step?",
      "descriptionExpanded": "Make a choice or change type.",
      "sectionWhoOrWhat": "Who or what takes over?",
      "sectionNotYetDefined": "Not yet defined",
      "sidebarTypeHeading": "Type",
      "statusReadyToSave": "Ready to save.",
      "statusPickToContinue": "Choose an option to continue.",
      "saveError": "Could not save the successor. Please try again.",
      "ctaConfirmEntity": "Save",
      "type": {
        "person": {
          "sublabel": "An employee"
        },
        "team": {
          "sublabel": "A team in the organization"
        },
        "role": {
          "sublabel": "A function in the organization"
        },
        "system": {
          "sublabel": "Automated step"
        },
        "externalContact": {
          "sublabel": "Customer, partner, authority"
        },
        "unclear": {
          "sublabel": "Process owner decides later"
        },
        "none": {
          "sublabel": "The process ends here"
        }
      },
      "unclear": {
        "cardTitle": "Unclear — decide later",
        "cardBody": "Mark the step as unclear. The process owner is notified once recording is finished and then decides who takes over the next step.",
        "willBeNotified": "WILL BE NOTIFIED",
        "ctaConfirm": "Mark as open"
      },
      "none": {
        "cardTitle": "No successor",
        "cardBody": "(Process end)",
        "warning": "Make sure no output to a further step is expected.",
        "ctaConfirm": "End process"
      }
    },
    "assignee": {
      "title": "Assign step",
      "descriptionCollapsed": "Who or what performs this process step?",
      "descriptionExpanded": "Make a choice or change type."
    },
    "starter": {
      "title": "Add process starter",
      "descriptionCollapsed": "Who or what starts this process?",
      "descriptionExpanded": "Make a choice or change type."
    },
    "reassign": {
      "title": "Next assignee",
      "descriptionCollapsed": "Who or what takes over the next process step?",
      "descriptionExpanded": "Make a choice or change type."
    }
  },
  "recording": {
    "finishDisabled": {
      "title": "Cannot finish yet:",
      "missingActionType": "Choose what this step does (task or decision)",
      "missingInput": "Add at least one input",
      "missingTaskDescription": "Describe what you do in this step",
      "missingSuccessor": "Choose who or what comes next",
      "missingOutput": "Define the output of this step",
      "missingDecisionRule": "Complete the decision rules"
    },
    "startDisabled": {
      "title": "Cannot start yet:",
      "missingStartEvent": "Configure the start event",
      "missingSuccessor": "Choose who or what comes next"
    }
  }
}
